import React, { Component } from 'react'
import { connect } from 'react-redux'
import { saveCampaignPages, saveCampaignPageContent } from "../../../actions/campaignActions";
import { buildTransaction } from '../../../actions/generalActions';
import { CampaignService } from '../../../services';

export class CampaignContainer extends Component {

  fetchCampaignPages() {
    const { user, campaign } = this.props
    const { client } = user
    const slug = client && client.slug ? client.slug : '';

    if (campaign.slug === null) {
      return
    }

    const payload = {
      client_slug: slug, 
      slug: campaign.slug,
    }

    this.props.startTransaction(()=>
      CampaignService.getPagesList(payload).then((response) => {
        const { "campaign/pages": pages } = response.data
        console.log('Campaign Pages -> ', pages)
        this.props.saveCampaignPages({pages});

        pages.map((page, key) => (
          CampaignService.getPageContent({...payload, page_id: page.id, detailed: false}).then((response) => {
            const { "campaign/page": page } = response.data
            console.log(' Page Content -> ', page)

            if (page.content_blocks.length > 0) {
              this.loadContentBlock( payload, page, 0)
            }
          })
        ))
      })
    )
  }

  loadContentBlock( payload, page, index){
    let content_block = page.content_blocks[index]

    CampaignService.getPageContentBlock({...payload, page_id: page.id, content_block_id: content_block.id, detailed: true}).then((response) => {
      const { "campaign/content_block": content_block } = response.data
      page.content_blocks[index] = content_block
      console.log(' Page Content -> ', page)

      index++;
      if (index >= page.content_blocks.length) {
        // update page content after interation has finished
        this.props.saveCampaignPageContent(page);
        return
      }

      this.loadContentBlock( payload, page, index)
    }).catch((error) => {
      const response = error.response;
      const rollbar = window.Rollbar;
      if(response){
        const status = error.response.status;
        switch (status) {
          case 500:
            if (rollbar) {
              rollbar.error(error)
            }
            break    
        }
      }
      else{
        if (rollbar) {
          rollbar.error(error)
        }
      }

      index++;
      if (index >= page.content_blocks.length) {
        // update page content after interation has finished
        this.props.saveCampaignPageContent(page);
        return
      }

      this.loadContentBlock( payload, page, index)
    })
  }

  componentDidMount(){
    this.fetchCampaignPages();
  }
 
  render() {
    const {component: Component, ...rest} = this.props
    return (
      <Component {...rest}/>
    )
  }
}

const mapStateToProps = (state) => ({
  campaign: state.campaignReducer.campaign,
  user: state.userReducer.user,
  banners: state.homepageBannersReducer.banners
})

const mapDispatchToProps = (dispatch) => ({
  saveCampaignPages: (pages) => { dispatch(saveCampaignPages(pages)) },
  saveCampaignPageContent: (page) => { dispatch(saveCampaignPageContent(page)) },
  startTransaction: buildTransaction(dispatch)
})

const Container = connect(mapStateToProps, mapDispatchToProps)(CampaignContainer)

export const withCampaignContainer = (component) => {
  return (props)=> <Container component={component} {...props}/>
}

export default Container
